export default __webpack_public_path__ + "static/media/vEmpire_logo_large.db6e5642.jpeg";